/* eslint-disable react/display-name */
import * as React from 'react';

import { BrazeConsumer } from '../braze-consumer/braze-consumer';
import { BrazeContext } from '../braze-provider/braze-provider';
import { Prescreen } from '../consumers/prescreen-consumer/prescreen-consumer';
import { SlideUp } from '../consumers/slide-up-consumer/slide-up-consumer';
import { Teaser } from '../consumers/teaser-consumer/teaser-consumer';
import { Placement } from '../placements';

const withBraze =
  (placement: Placement) =>
  (
    OpenComponent: typeof Teaser | typeof Prescreen | typeof SlideUp,
    EmptyComponent: React.FC = () => null
  ) =>
  () => (
    <BrazeContext.Consumer>
      {({ subscribeConsumer, trackingLibrary }) => {
        return (
          <BrazeConsumer
            placement={placement}
            subscribeConsumer={subscribeConsumer}
            openComponent={OpenComponent}
            emptyComponent={EmptyComponent}
            trackingLibrary={trackingLibrary}
          />
        );
      }}
    </BrazeContext.Consumer>
  );

export default withBraze;
